export enum UNDERTONE {
    COOL = 'cool_undertone',
    NEUTRAL = 'neutral_undertone',
    WARM = 'warm_undertone',
    GOLDEN = 'golden_undertone'
}
